'use strict';

const ApplePay = require('./applePay');
const AlertHandlerModel = require('../alertHandler');
const alertHandlerInstance = new AlertHandlerModel();
const helper = require('../../helpers/helper');

class ApplePayPdp extends ApplePay {
    /**
     * Initiates the Apple Pay functionality
     */
    async initApplePay() {
        const applePayConfig = await this.applePay.config();

        if (applePayConfig.isEligible) {
            this.renderApplePay();
            this.applyApplePayButtonBehaviour();

            this.applePayBtnEl.addEventListener('click', () => {
                this.onClick(applePayConfig);
            });
        }
    }

    /**
    * On Apple Pay pdp button click
    * @param {ApplePayConfig} applePayConfig An Apple pay config object generated by PayPal
    */
    onClick(applePayConfig) {
        const addToCartResult = helper.addProductToCart('.js-applepay-pdp-button-wrap');

        if (!addToCartResult.error) {
            this.saveApplePayTotalData();
            this.createApplePaySession(applePayConfig);
        } else {
            alertHandlerInstance.showError(this.applePayConfigs.errorMessages.couldNotAddProductToTheCart);
        }
    }

    /**
    * Handling pdp Apple Pay behavior
    */
    initApplePayButtonBehaviorOnPdp() {
        const applePayPDPButton = this.applePayButtonWrapEl;
        const pdpHelper = require('../../pdp/pdpHelper');

        if (applePayPDPButton) {
            const addToCartButtonDisabled = pdpHelper.isAddToCartButtonDisabled();
            const zeroProductPrice = pdpHelper.isZeroPdpProductPrice();
            const basketNotEmpty = pdpHelper.isBasketNotEmpty();

            if (addToCartButtonDisabled || zeroProductPrice || basketNotEmpty) {
                helper.hideButton(applePayPDPButton);
            }

            $('body').on('product:afterAddToCart', function() {
                helper.hideButton(applePayPDPButton);
            });
            $('body').on('cart:update', pdpHelper.handleApplePayButtonOnUpdate);
            $('body').on('product:statusUpdate', pdpHelper.handleApplePayButtonOnUpdate);
        }
    }

    /**
    * Applies Apple Pay pdp button behavior
    */
    applyApplePayButtonBehaviour() {
        const applePayButton = this.applePayButtonWrapEl;
        const isProductSet = Boolean(document.querySelector('.set-items'));

        if (applePayButton && !isProductSet) {
            this.initApplePayButtonBehaviorOnPdp();
        }
    }
}

module.exports = ApplePayPdp;
